import { useNavigate } from "react-router-dom";
import TUSC01 from "../../../../assets/png/TUSC01.png";
import { RouterPaths } from "../../../../router/router";

const UtilityVehicles = ({ subMenuWidth, subManuItem, openManu, closeAllManu, setSubManuItem, height }) => {
  const navigate = useNavigate();
  return (
    <div
      onMouseEnter={() => openManu()}
      onMouseLeave={() => closeAllManu()}
      className={`absolute z-[10001]`}
      style={{ left: `${subMenuWidth.offsetLeft - 305}px` }}
    >
      <div className="mr-[33px]" style={{ top: `${height}px`, width: `${subMenuWidth.offsetWidth + 305}px` }}>
        <div className="bg-[#F2F2F2]">
          <div className="grid grid-cols-4 gap-4">
            <div className="col-span-1 border-r-[1px] border-r-[#292929]">
              <div
                className="border-b-[1px] border-b-black py-[8px] cursor-pointer"
                onMouseEnter={() => setSubManuItem("MODEL")}
              >
                <div
                  className={`${subManuItem == "MODEL" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                >
                  MODELS
                </div>
              </div>
            </div>

            {/* MODEL */}
            {subManuItem == "MODEL" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  MODELS
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.EFI);
                        closeAllManu();
                      }}
                    >
                      1000EFI-2 Gasoline
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.TU1500E2);
                        closeAllManu();
                      }}
                    >
                      1500E-2 Electric
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.TU1500E3);
                        closeAllManu();
                      }}
                    >
                      1500E-3 Electric
                    </div>
                    {/* <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.TU1500E4);
                        closeAllManu();
                      }}
                    >
                      1500E-4 Electric
                    </div> */}
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.TUSC2500E1);
                        closeAllManu();
                      }}
                    >
                      SC2500E-01 Dual Motor
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.TUDC2500E1);
                        closeAllManu();
                      }}
                    >
                      DC2500E-01 Dual Motor
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[350px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">BUILD MY TUATARA</div>
                      <div>
                        <div>
                          <img src={TUSC01} alt="Build My Tuatara - SC2500E-01 Model" className="w-[350px]" />
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        className="w-full bg-[#7ABF5B] font-[Roboto] text-[20px] text-[#fff] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        GET STARTED
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UtilityVehicles;
